import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext } from "react";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Typography from "@mui/material/Typography";
import { useShowDebugOther } from "@plansoft-configuration-renderer/debug";
import { DataTable } from "../DataTable/DataTable";
import { useDataTableNumberFormatter, } from "../DataTable/useDataTableNumberFormatter";
import { useDataTablePriceFormatter, } from "../DataTable/useDataTablePriceFormatter";
import RenderCellAccordion from "./renderer/RenderCellAccordion";
import RenderCellDebug from "./renderer/RenderCellDebug";
import RenderCellDetails from "./renderer/RenderCellDetails";
import RenderCellName from "./renderer/RenderCellName";
var ColumnField;
(function (ColumnField) {
    ColumnField["Debug"] = "debug";
    ColumnField["DebugPrice"] = "debugPrice";
    ColumnField["DebugTotalPrice"] = "debugTotalPrice";
    ColumnField["Details"] = "details";
    ColumnField["Level"] = "level";
    ColumnField["Mass"] = "mass";
    ColumnField["Name"] = "name";
    ColumnField["PartId"] = "partId";
    ColumnField["Position"] = "position";
    ColumnField["Price"] = "price";
    ColumnField["Quantity"] = "quantity";
    ColumnField["TotalMass"] = "totalMass";
    ColumnField["TotalPrice"] = "totalPrice";
    ColumnField["TypeCode"] = "typeCode";
})(ColumnField || (ColumnField = {}));
export const BillOfMaterialsContext = createContext({});
export const BillOfMaterialsIsCollapsibleContext = createContext(false);
function getIsCollapsible(data) {
    let boolean = false;
    data.forEach((cbi) => {
        var _a;
        if (((_a = cbi.bom) === null || _a === void 0 ? void 0 : _a.items) && cbi.bom.items.length > 0) {
            boolean = true;
        }
    });
    return boolean;
}
function formatConfigurationBomItemsToDataTableRows(data, columns, formatPrice, formatNumber) {
    const rows = data.map((row) => {
        var _a, _b;
        const rowTmp = {
            id: row.id,
            rows: ((_a = row.bom) === null || _a === void 0 ? void 0 : _a.items)
                ? formatConfigurationBomItemsToDataTableRows((_b = row.bom) === null || _b === void 0 ? void 0 : _b.items, columns, formatPrice, formatNumber)
                : undefined,
        };
        columns.forEach((col) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12;
            switch (col.field) {
                case ColumnField.Price:
                    rowTmp[col.field] = ((_b = (_a = row.prices) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.price)
                        ? formatPrice((_d = (_c = row.prices) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.price, (_f = (_e = row.prices) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.unitId)
                        : undefined;
                    break;
                case ColumnField.TotalPrice:
                    rowTmp[col.field] = ((_h = (_g = row.prices) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.totalPrice)
                        ? formatPrice((_k = (_j = row.prices) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.totalPrice, (_m = (_l = row.prices) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.unitId)
                        : undefined;
                    break;
                case ColumnField.DebugPrice:
                    rowTmp[col.field] = ((_p = (_o = row.prices) === null || _o === void 0 ? void 0 : _o[1]) === null || _p === void 0 ? void 0 : _p.price)
                        ? (((_r = (_q = row.prices) === null || _q === void 0 ? void 0 : _q[1]) === null || _r === void 0 ? void 0 : _r.type)
                            ? ((_t = (_s = row.prices) === null || _s === void 0 ? void 0 : _s[1]) === null || _t === void 0 ? void 0 : _t.type) + " "
                            : undefined) +
                            formatPrice((_v = (_u = row.prices) === null || _u === void 0 ? void 0 : _u[1]) === null || _v === void 0 ? void 0 : _v.price, (_x = (_w = row.prices) === null || _w === void 0 ? void 0 : _w[1]) === null || _x === void 0 ? void 0 : _x.unitId)
                        : undefined;
                    break;
                case ColumnField.DebugTotalPrice:
                    rowTmp[col.field] = ((_z = (_y = row.prices) === null || _y === void 0 ? void 0 : _y[1]) === null || _z === void 0 ? void 0 : _z.totalPrice)
                        ? (((_1 = (_0 = row.prices) === null || _0 === void 0 ? void 0 : _0[1]) === null || _1 === void 0 ? void 0 : _1.type)
                            ? ((_3 = (_2 = row.prices) === null || _2 === void 0 ? void 0 : _2[1]) === null || _3 === void 0 ? void 0 : _3.type) + " "
                            : undefined) +
                            formatPrice((_5 = (_4 = row.prices) === null || _4 === void 0 ? void 0 : _4[1]) === null || _5 === void 0 ? void 0 : _5.totalPrice, (_7 = (_6 = row.prices) === null || _6 === void 0 ? void 0 : _6[1]) === null || _7 === void 0 ? void 0 : _7.unitId)
                        : undefined;
                    break;
                case ColumnField.Mass:
                    rowTmp[col.field] = row.mass
                        ? formatNumber(row.mass, row.massUnitId)
                        : "";
                    break;
                case ColumnField.TotalMass:
                    rowTmp[col.field] = row.totalMass
                        ? formatNumber(row.totalMass, row.massUnitId)
                        : "";
                    break;
                case ColumnField.Details:
                    rowTmp[col.field] = formatDetails({
                        description: row.description,
                        manufacturer: row.manufacturer,
                        type: row.type,
                        image: row.image,
                    });
                    break;
                case ColumnField.Debug:
                    rowTmp[col.field] = row;
                    break;
                case ColumnField.Level:
                    rowTmp[col.field] = row.level;
                    break;
                case ColumnField.Name:
                    rowTmp[col.field] = (_8 = row.name) !== null && _8 !== void 0 ? _8 : "";
                    break;
                case ColumnField.PartId:
                    rowTmp[col.field] = (_9 = row.partId) !== null && _9 !== void 0 ? _9 : "";
                    break;
                case ColumnField.Position:
                    rowTmp[col.field] = (_10 = row.position) !== null && _10 !== void 0 ? _10 : "";
                    break;
                case ColumnField.Quantity:
                    rowTmp[col.field] = (_11 = row.quantity) === null || _11 === void 0 ? void 0 : _11.toString();
                    break;
                case ColumnField.TypeCode:
                    rowTmp[col.field] = (_12 = row.typeCode) !== null && _12 !== void 0 ? _12 : "";
                    break;
                default:
                    break;
            }
        });
        return rowTmp;
    });
    return rows;
}
/**
 * Display bill of materials
 * @param props
 * @returns
 */
export function BillOfMaterialsDisplay({ data, hideHeading = false, languageCode, }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const showDebug = useShowDebugOther();
    const formatPrice = useDataTablePriceFormatter(languageCode);
    const formatNumber = useDataTableNumberFormatter(languageCode);
    // ToDo: Translations & API?
    const columns = [
        {
            field: ColumnField.Level,
            headerName: "Level",
            renderCell: RenderCellAccordion,
        },
        { field: ColumnField.Position, headerName: "Pos." },
        { field: ColumnField.PartId, headerName: "Part Id" },
        { field: ColumnField.Name, headerName: "Name", renderCell: RenderCellName },
        { field: ColumnField.TypeCode, headerName: "Typecode-Fragment" },
        {
            field: ColumnField.Quantity,
            headerName: "Quantity",
            type: "number",
        },
        {
            field: ColumnField.Mass,
            headerName: "Mass",
            type: "number",
        },
        {
            field: ColumnField.TotalMass,
            headerName: "Total Mass",
            type: "number",
        },
        {
            field: ColumnField.Price,
            headerName: "Price",
            type: "number",
        },
        {
            field: ColumnField.TotalPrice,
            headerName: "Total Price",
            type: "number",
        },
        {
            field: ColumnField.DebugPrice,
            headerName: "Debug Price",
            type: "number",
        },
        {
            field: ColumnField.DebugTotalPrice,
            headerName: "Debug Total Price",
            type: "number",
        },
        {
            field: ColumnField.Details,
            headerName: "",
            renderCell: RenderCellDetails,
        },
        {
            field: ColumnField.Debug,
            headerName: "Debug",
            renderCell: RenderCellDebug,
        },
    ];
    const rows = data.items
        ? formatConfigurationBomItemsToDataTableRows(data.items, columns, formatPrice, formatNumber)
        : undefined;
    const footer = {
        totalMass: data.mass
            ? Number(data.mass) + (data.massUnitId ? data.massUnitId : "")
            : "",
        totalPrice: ((_b = (_a = data.prices) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.totalPrice)
            ? formatPrice((_d = (_c = data.prices) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.totalPrice, (_f = (_e = data.prices) === null || _e === void 0 ? void 0 : _e[1]) === null || _f === void 0 ? void 0 : _f.unitId)
            : undefined,
        debugTotalPrice: ((_h = (_g = data.prices) === null || _g === void 0 ? void 0 : _g[1]) === null || _h === void 0 ? void 0 : _h.totalPrice)
            ? (((_k = (_j = data.prices) === null || _j === void 0 ? void 0 : _j[1]) === null || _k === void 0 ? void 0 : _k.type) ? ((_m = (_l = data.prices) === null || _l === void 0 ? void 0 : _l[1]) === null || _m === void 0 ? void 0 : _m.type) + " " : undefined) +
                formatPrice((_p = (_o = data.prices) === null || _o === void 0 ? void 0 : _o[1]) === null || _p === void 0 ? void 0 : _p.totalPrice, (_r = (_q = data.prices) === null || _q === void 0 ? void 0 : _q[1]) === null || _r === void 0 ? void 0 : _r.unitId)
            : undefined,
    };
    const visibleFields = [
        ColumnField.Level,
        ColumnField.Position,
        ColumnField.PartId,
        ColumnField.Name,
        ColumnField.TypeCode,
        ColumnField.Quantity,
        ColumnField.Mass,
        ColumnField.TotalMass,
        ColumnField.Price,
        ColumnField.TotalPrice,
        ColumnField.Details,
    ];
    if (showDebug) {
        visibleFields.push(ColumnField.DebugPrice);
        visibleFields.push(ColumnField.DebugTotalPrice);
        visibleFields.push(ColumnField.Debug);
    }
    const isCollapsible = data.items ? getIsCollapsible(data.items) : false;
    return (_jsx(BillOfMaterialsContext.Provider, { value: data, children: _jsxs(BillOfMaterialsIsCollapsibleContext.Provider, { value: isCollapsible, children: [!hideHeading && (_jsx(Typography, { variant: "h5", sx: {
                        pb: 2,
                    }, children: data.name })), rows && (_jsx(TableContainer, { component: Paper, sx: { width: "100%", maxHeight: "calc(75vh - 150px)" }, children: _jsx(DataTable, { rows: rows, columns: columns, visibleFields: visibleFields, footer: footer }) }))] }) }));
}
function formatDetails(details) {
    if (!details || Object.keys(details).length <= 0) {
        return undefined;
    }
    Object.keys(details).forEach((key) => {
        if (details[key] === undefined ||
            details[key] === "") {
            delete details[key];
        }
    });
    return details;
}
//# sourceMappingURL=BillOfMaterialsDisplay.js.map